
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8 0h6a8 8 0 018 8v2.615a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z","fill":"#B15DCB"}}),_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M5.077 3.385h11.846V15.23H5.077z"}}),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M15.23 8.885a.846.846 0 111.693 0v4.653c0 .935-.758 1.693-1.692 1.693H6.769a1.692 1.692 0 01-1.692-1.693V5.077c0-.935.758-1.692 1.692-1.692h5.077a.846.846 0 010 1.692H6.77v8.461h8.462V8.885z","opacity":".45"}}),_c('path',{attrs:{"d":"M10.9 10.199l3.622-5.585a.846.846 0 111.417.926l-4.093 6.306a.846.846 0 01-1.184.237L7.985 9.725a.846.846 0 11.953-1.399L10.9 10.2z"}})])])])])
          )
        }
      }
    